/* Realistic device frames used across the marketing pages. */

export const RealisticPhone = ({ src, alt, className = '', camera = 'island', radius = 3 }) => (
  <div className={`relative ${className}`}>
    {/* side buttons */}
    <span className="absolute top-[15%] -left-[3px] w-[3px] h-7 rounded-l-sm" style={{ background: '#83838C' }} aria-hidden="true" />
    <span className="absolute top-[24%] -left-[3px] w-[3px] h-11 rounded-l-sm" style={{ background: '#83838C' }} aria-hidden="true" />
    <span className="absolute top-[35%] -left-[3px] w-[3px] h-11 rounded-l-sm" style={{ background: '#83838C' }} aria-hidden="true" />
    <span className="absolute top-[20%] -right-[3px] w-[3px] h-16 rounded-r-sm" style={{ background: '#83838C' }} aria-hidden="true" />
    {/* titanium rim */}
    <div
      className="p-[3px]"
      style={{
        borderRadius: `${radius}rem`,
        background: 'linear-gradient(145deg, #EDEDF1 0%, #9C9CA6 28%, #DFDFE5 55%, #74747E 100%)',
        boxShadow: '0 34px 70px rgba(23, 17, 48, 0.5), 0 8px 20px rgba(23,17,48,0.35)',
      }}
    >
      {/* black bezel */}
      <div className="p-[7px]" style={{ borderRadius: `${radius - 0.18}rem`, background: '#0A0A0F' }}>
        {/* screen */}
        <div className="relative overflow-hidden" style={{ borderRadius: `${radius - 0.65}rem`, background: '#FDF8EC' }}>
          <div style={{ height: camera === 'punch' ? 20 : 36, background: '#FDF8EC' }} aria-hidden="true" />
          <img src={src} alt={alt} className="w-full h-auto block" loading="lazy" />
          {camera === 'island' ? (
            <span className="absolute top-2.5 left-1/2 -translate-x-1/2 rounded-full" style={{ width: 84, height: 22, background: '#0A0A0F' }} aria-hidden="true" />
          ) : (
            <span className="absolute top-2 left-1/2 -translate-x-1/2 rounded-full" style={{ width: 13, height: 13, background: '#0A0A0F', boxShadow: '0 0 0 2.5px rgba(255,255,255,0.08)' }} aria-hidden="true" />
          )}
          {/* screen glare */}
          <span
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'linear-gradient(115deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.05) 24%, transparent 42%)' }}
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  </div>
);

export const RealisticLaptop = ({ src, alt, className = '' }) => (
  <div className={`relative ${className}`}>
    {/* lid */}
    <div
      className="p-[9px] pb-[10px]"
      style={{
        borderRadius: '0.85rem 0.85rem 0.3rem 0.3rem',
        background: 'linear-gradient(145deg, #EFEFF3 0%, #A6A6B0 30%, #DCDCE2 62%, #82828C 100%)',
        boxShadow: '0 30px 60px rgba(23,17,48,0.45), 0 8px 18px rgba(23,17,48,0.3)',
      }}
    >
      <div className="px-[7px] pb-[7px]" style={{ borderRadius: '0.6rem 0.6rem 0.18rem 0.18rem', background: '#0A0A0F' }}>
        {/* camera strip */}
        <div className="flex items-center justify-center" style={{ height: 15 }} aria-hidden="true">
          <span className="rounded-full" style={{ width: 5, height: 5, background: '#2C2C33', boxShadow: '0 0 0 1.5px rgba(255,255,255,0.06)' }} />
        </div>
        {/* screen */}
        <div className="relative overflow-hidden" style={{ borderRadius: 3, background: '#FFFFFF' }}>
          <img src={src} alt={alt} className="w-full h-auto block" loading="lazy" />
          <span
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'linear-gradient(112deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.06) 26%, transparent 46%)' }}
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
    {/* hinge + base */}
    <div
      className="relative"
      style={{
        width: '112%',
        marginLeft: '-6%',
        height: 13,
        borderRadius: '0 0 12px 12px',
        background: 'linear-gradient(180deg, #D5D5DC 0%, #A2A2AC 55%, #74747E 100%)',
        boxShadow: '0 16px 26px rgba(23,17,48,0.4)',
      }}
      aria-hidden="true"
    >
      <span
        className="absolute left-1/2 -translate-x-1/2 top-0"
        style={{ width: '17%', height: 5, borderRadius: '0 0 6px 6px', background: '#8A8A94' }}
      />
    </div>
  </div>
);
